import { render, staticRenderFns } from "./portfolioList.vue?vue&type=template&id=0e3ecf37&"
import script from "./portfolioList.vue?vue&type=script&lang=js&"
export * from "./portfolioList.vue?vue&type=script&lang=js&"
import style0 from "./portfolioList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports